export enum PaymentMethodCodeEnum {
  applePay = 'apple_pay',
  bankTransfer = 'bank_transfer',
  blik = 'blik',
  bypass = 'bypass',
  card = 'card',
  cellulant = 'cellulant',
  dotPay = 'dot_pay',
  free = 'free',
  freeVouchers = 'free_vouchers',
  googlePay = 'google_pay',
  mbway = 'mbway',
  paypal = 'paypal',
  token = 'token',
  wallet = 'wallet'
}
